import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeClock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3ZM16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM16.9933 8.88338C16.9355 8.38604 16.5128 8 16 8C15.4477 8 15 8.44772 15 9V16L15.0067 16.1166C15.0645 16.614 15.4872 17 16 17H23L23.1166 16.9933C23.614 16.9355 24 16.5128 24 16L23.9933 15.8834C23.9355 15.386 23.5128 15 23 15H17V9L16.9933 8.88338Z"
	})
});
export default SvgTimeClock;
